var map = {
	"./123.js": 542,
	"./234.js": 543,
	"./235.js": 544,
	"./6x36.js": 545,
	"./contact.js": 546,
	"./home.js": 547,
	"./keno.js": 548,
	"./kenoBao.js": 549,
	"./ketqua.js": 550,
	"./ktmb.js": 551,
	"./max3d.js": 552,
	"./max3dP.js": 553,
	"./max4d.js": 554,
	"./mega.js": 555,
	"./power.js": 556,
	"./profile.js": 557,
	"./shopHIstory.js": 558,
	"./thantai.js": 559,
	"./transHistory.js": 560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;